// extracted by mini-css-extract-plugin
export default {"chartContainer":"Co2Chart_chartContainer__JLdfW"};